import { render } from "./InputTel.vue?vue&type=template&id=fbc5c210&scoped=true"
import script from "./InputTel.vue?vue&type=script&lang=js"
export * from "./InputTel.vue?vue&type=script&lang=js"

import "./InputTel.vue?vue&type=style&index=0&id=fbc5c210&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc5c210"]])

export default __exports__